export const BRAND_HOOK_SHORT =
  'Devon & Cornwall web design: £0 upfront, pay-monthly hosting, SSL & SEO. WebCodeCraft — South West UK.';

export const BRAND_LEDE_LONG =
  "WebCodeCraft is redefining the digital landscape for businesses across Devon and Cornwall. We believe that a world-class online presence should not be gated behind massive upfront costs. Our mission is simple: to provide elite-tier web development and SEO services that act as a 24/7 sales force for your business.";

export const BRAND_WHY_CHOOSE_ITEMS = [
  {
    title: 'The zero-cost advantage',
    body:
      'We build and design your professional website without a large upfront invoice. You pay a manageable monthly hosting and care fee so capital stays in your business where it belongs.',
  },
  {
    title: 'Hyper-local SEO',
    body:
      'We do not only publish pages—we aim to earn visibility. From Plymouth and Exeter to Truro and the English Riviera, we focus on geo-aware SEO that helps you show up for customers in your immediate area.',
  },
  {
    title: 'Security and performance first',
    body:
      'Modern stacks, fast delivery, and security-minded hosting and maintenance. In an era of constant threats, we treat protection and uptime as core product—not an afterthought.',
  },
  {
    title: 'A partnership, not a one-off project',
    body:
      'Based in the South West, we act as long-term digital partners: ongoing support, backup-minded operations, and optimisation aligned with the plans we publish.',
  },
];

export const BRAND_CLOSING =
  'Whether you are a startup in Barnstaple or an established business in Falmouth, WebCodeCraft delivers the technical depth and local relevance to compete seriously online.';

export const BRAND_LOCAL_BUSINESS_DESCRIPTION = [
  BRAND_LEDE_LONG,
  'Why choose WebCodeCraft?',
  ...BRAND_WHY_CHOOSE_ITEMS.map((item) => `${item.title}: ${item.body}`),
  BRAND_CLOSING,
].join(' ');
